import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagVC = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M36.957 3.04A24.888 24.888 0 0 0 25.001 0a24.889 24.889 0 0 0-11.957 3.04L10.87 25l2.174 21.96A24.89 24.89 0 0 0 25.001 50a24.89 24.89 0 0 0 11.956-3.04L39.131 25 36.957 3.04Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M13.043 46.96V3.04C5.274 7.28 0 15.524 0 25s5.272 17.72 13.043 21.96Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M49.999 25c0-9.476-5.273-17.72-13.044-21.96v43.92C44.726 42.72 50 34.476 50 25ZM19.565 31.522l-4.348-6.521 4.348-6.522L23.913 25l-4.348 6.522ZM30.435 31.522l-4.348-6.521 4.348-6.522L34.783 25l-4.348 6.522ZM24.999 40.218l-4.348-6.522 4.348-6.522 4.348 6.522-4.348 6.522Z"
}));
FlagVC.displayName = 'FlagVC';
export default withFlagWrapper(FlagVC);
//# sourceMappingURL=index.js.map